import MultiSelectDropdown, { Option } from "@crescentParts/Components/MultiSelectDropDown";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import { OrderStatusMappingModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        orderStatusMappings: getOrderStatusMappingDataView(state).value,
        parameter: state.pages.orderHistory.getOrdersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldStatusStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const statusStyles: OrderHistorySearchFieldStatusStyles = {};
const styles = statusStyles;

class OrderHistorySearchFieldStatus extends React.Component<Props> {
    handleChange = (option: Option) => {
        const isSelected =
            this.props.parameter.status &&
            this.props.parameter.status.length > 0 &&
            this.props.parameter.status.indexOf(option.value) > -1;
        let status: string[] =
            this.props.parameter.status && this.props.parameter.status.length > 0
                ? [...this.props.parameter.status]
                : [];
        if (isSelected) {
            status = this.props.parameter.status!.filter(val => option.value !== val);
        } else {
            status.push(option.value);
        }
        if (status.length > 0) {
            this.props.updateSearchFields({
                status,
                displayName: option.label,
            });
        } else {
            this.props.updateSearchFields({ status: undefined });
        }
    };

    render() {
        const options = this.props.orderStatusMappings || [];
        const uniqueOptions = new Map<string, string[]>();
        for (const option of options) {
            const erpOrderStatuses = uniqueOptions.get(option.displayName) || [];
            erpOrderStatuses.push(option.erpOrderStatus);
            uniqueOptions.set(option.displayName, erpOrderStatuses);
        }

        const dropDownOptions: Option[] = Array.from(uniqueOptions, ([name, values]) => ({ name, values })).map(
            option => ({
                value: option.values.join(","),
                label: option.name,
            }),
        );

        const selectedOptions: Option[] =
            this.props.parameter.status && this.props.parameter.status.length > 0
                ? this.props.parameter.status.map(val => ({
                      value: val,
                      label: dropDownOptions.find(opt => opt.value === val)?.label || "",
                  }))
                : [];

        return (
            <SearchFieldWrapper extendedStyles={styles.wrapper}>
                <MultiSelectDropdown
                    label="Status"
                    handleOptionClick={this.handleChange}
                    options={dropDownOptions}
                    selectedOptions={selectedOptions}
                />
            </SearchFieldWrapper>
        );
    }
}

function findDisplayName(erpOrderStatus: string, orderStatusMappings: OrderStatusMappingModel[] = []) {
    const arrOfStatus = erpOrderStatus.split(",");

    let returnVal;
    for (let i = 0; i < orderStatusMappings.length; i++) {
        const option = orderStatusMappings[i];
        if (arrOfStatus.includes(option.erpOrderStatus)) {
            returnVal = option.displayName;
            break;
        }
    }
    return returnVal;
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldStatus),
    definition: {
        group: "Order History",
        displayName: "Multi Select Status",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
